export default "__VITE_ASSET__2db97c00__"